import React, { useEffect, useRef, useState } from "react";
import styles from "./transactiondetail.module.css";
import { Col, Row } from "react-bootstrap";
import DownIcon from "../../component/signup/assets/iconDown.svg";
import statementIcon from "../../public/assets/statementIconYellow.png";
import close from "../../component/signup/assets/savingsClose.svg";
import moment from "moment";
import { getTransactionDetailUsingId, getTransactionList } from "../../api";
import TransactionDatePicker from "../../common/transactionDatePicker";
import leftIcon from "../../public/assets/LeftPageIcon.svg";
import rightIcon from "../../public/assets/RightPageIcon.svg";
import CashMgmtModal from "./CashMgmtModal";
import TransactionDetailsModal from "./transactiondetailModal";
import { addDays } from "date-fns";
import download from "../../public/assets/Icon.svg";
import noDataFound from "../../public/assets/NoDataFound.svg";
import filter from "../../public/assets/savingFilter.svg";
import { addCommasInPrice, onOpenDocument } from "../../utils";
import { useMyContext } from "../../myContext";

const TransactionDetail = () => {
  const [selectedInputPill, setSelectedInputPill] =
    useState("All Transactions");
  const date = new Date();
  const [startDate, setStartDate] = useState(addDays(date, -30));
  const [endDate, setEndDate] = useState(date);
  const [showTransactionTypePopup, setShowTransactionTypePopup] =
    useState(false);
  const [selectedPill, setSelectedPill] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [collection, setCollection] = useState();
  const [tranId, setTranId] = useState();
  const [showTransactionTypePopupMobile, setShowTransactionTypePopupMobile] =
    useState(false);
  const [totalTransactionCount, setTotalTransactionCount] = useState([]);
  const [totalPaginationPage, setTotalPaginationPage] = useState(1);
  const [showTransactionDetails, setshowTransactionDetails] = useState(false);
  const [leftCalender, setLeftCalender] = useState(null);
  const [rightCalender, setRightCalender] = useState(null);
  const [transactionItem, setTransactionItem] = useState();
  const [downloadingSWIFT, setDownloadingSWIFT] = useState(false);
  const { offlineTransactionFlow } = useMyContext();
  const ref = useRef();
  const countPerPage = 10;

  const transactionValue = [
    { value: "All Transactions", color: "#767C8F", pillValue: "" },
    {
      value: "Successful",
      color: "#0DC014",
      pillValue: "COMPLETED",
    },
    {
      value: "Processing",
      color: "#FFCA4B",
      pillValue:
        "WAITING_FOR_FUND,FUND_RECEIVED,Initiated,PROCESSED,QUOTE_INITIATED,DOC_RECEIVED,A2_E_SIGNED,MANUAL_REVIEW",
    },
    {
      value: "Hold",
      color: "#FA5D05",
      pillValue: "DOCUMENTS_REJECTED",
    },
    {
      value: "Failed",
      color: "#FA274A",
      pillValue: "PAYMENT_FAILURE,FAILED,REJECTED,CANCELLED",
    },
    { value: "Refunded", color: "#767C8F", pillValue: "REFUNDED" },
    { value: "Expired", color: "#767C8F", pillValue: "EXPIRED" },
  ];

  const dateFormatter = (mydate) => {
    var curr_date = mydate.getDate();
    var curr_month = mydate.getMonth() + 1;
    var curr_year = mydate.getFullYear();
    if (curr_date < 10) {
      curr_date = "0" + curr_date;
    }
    if (curr_month < 10) {
      curr_month = "0" + curr_month;
    }
    mydate = `${curr_month}/${curr_date}/${curr_year}`;
    return mydate;
  };

  const parseDate = (value) => {
    const [day, month, year] = value.split("/");
    return `${year}-${day}-${month}`;
  };

  const getFundTransactionDetail = () => {
    var from = parseDate(dateFormatter(startDate));
    var to = parseDate(dateFormatter(endDate));
    var status = selectedPill;
    getTransactionList(currentPage, from, to, status)
      .then((response) => {
        if (response.status === 200) {
          setTotalPaginationPage(
            Math.ceil(response.data.length / countPerPage)
          );
          setCollection(response.data ? response.data.transactionData : []);
          setTotalTransactionCount(response.data.length);
        } else {
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    sessionStorage.setItem("transactionPage", "transaction-Detail");
    sessionStorage.setItem("isDocRequired", "false");
    const interval = setInterval(() => getFundTransactionDetail(), 10000);
    return () => {
      clearInterval(interval);
    };
  }, [selectedPill, currentPage, startDate, endDate]);

  useEffect(() => {
    getFundTransactionDetail();
  }, [currentPage, startDate, endDate, selectedPill]);

  const changeDate = (data, id) => {
    setCurrentPage(1);
    if (id === "Start_Date") {
      setStartDate(data);
    } else {
      setEndDate(data);
    }
  };

  const TransactionTypePopUp = (props) => {
    return (
      <div className={styles.transactionTypeContainer}>
        <div
          className={styles.savingsMobileCross}
          onClick={props.openTransaction}
        >
          <img src={close} alt="close-icon"></img>
        </div>
        {props.data.map((e, index) => {
          return (
            <span
              onClick={() => props.selectPill(e.pillValue, e.value)}
              className={styles.transactionTypeValue}
              style={{ color: e.color }}
            >
              <span
                className={styles.savingPillCircleColor}
                style={{ backgroundColor: e.color }}
              ></span>
              {e.value}
            </span>
          );
        })}
      </div>
    );
  };

  const seprateTimeAndDate = (e, type) => {
    if (type === "date") {
      const date = moment(e).format("D MMM YY");
      return date ? date : "--";
    }
    if (type === "time") {
      const time = moment(e).format("h:mm A z");
      return time ? time : "--";
    }
  };

  const pillSelection = (e, f) => {
    setSelectedPill(e);
    setShowTransactionTypePopup(false);
    setSelectedInputPill(f);
    setCurrentPage(1);
  };

  const openTransactionTypePopup = () => {
    setShowTransactionTypePopup(!showTransactionTypePopup);
  };

  const openTransactionDetails = () => {
    setshowTransactionDetails(!showTransactionDetails);
  };

  const goBack = (p) => {
    if (p !== 1) {
      const x = p - 1;
      setCurrentPage(x);
      const to = countPerPage * x;
      const from = to - countPerPage;
    } else {
    }
  };

  const goNext = (p) => {
    const x = p + 1;
    if (totalPaginationPage >= p + 1) {
      setCurrentPage(x);
      const to = countPerPage * x;
      const from = to - countPerPage;
    } else {
    }
  };

  const SendToBox = (name) => {
    var initial = name ? name.substring(0, 2).toUpperCase() : "?";
    return (
      <>
        <div className={styles.savingTableTransactionTypeValue}>
          <span className={styles.circleName}>{initial}</span>
          <p className={styles.sentToName}>{name}</p>
        </div>
      </>
    );
  };

  const downloadSwift = async (e, item) => {
    e.stopPropagation();
    setDownloadingSWIFT(true);
    try {
      const res = await getTransactionDetailUsingId(item.transactionId);
      setDownloadingSWIFT(false);
      onOpenDocument(res?.data?.transactionData?.swiftDocUrl, true);
    } catch (e) {
      setDownloadingSWIFT(false);
    }
  };

  const openTransactionTypePopupMobile = () => {
    setShowTransactionTypePopupMobile(!showTransactionTypePopupMobile);
  };

  return (
    <>
      <div className={styles.outerContainer}>
        <Row className={`pt-3 mt-3 ${styles.firstRow}`}>
          <Col md={6} className={styles.TransactionHeading}>
            Recent Transactions
          </Col>
          <Col lg={6} xs={2} style={{ padding: "0px" }}>
            <div className={styles.savingsDownloadButtonAlighnment}>
              <img src={download} alt="" style={{ margin: "2px" }}></img>
              Download
            </div>
          </Col>
        </Row>
        <Row className={`pt-2 ${styles.secondRow}`}>
          <Col
            xs={12}
            md={12}
            className={styles.savingsHideMobileFilter}
            style={{ padding: "0px" }}
            onClick={openTransactionTypePopupMobile}
          >
            <div className={styles.savingsMobileFilter}>
              <span className={styles.savingsMobileFilterText}>
                <img src={filter} alt="" style={{ marginRight: "10px" }}></img>
                {selectedInputPill}
              </span>
            </div>
            {showTransactionTypePopupMobile ? (
              <TransactionTypePopUp
                data={transactionValue}
                selectPill={pillSelection}
                openTransaction={openTransactionTypePopupMobile}
              />
            ) : (
              ""
            )}
          </Col>
          <Col
            xl={2}
            lg={3}
            md={4}
            sm={6}
            xs={6}
            className={styles.savingDatePickerWebPadding}
          >
            <TransactionDatePicker
              type={"From"}
              changeDate={changeDate}
              value={startDate}
              id="Start_Date"
              extraPad="0px"
              maxDate={endDate}
              align="left"
              leftCalender={leftCalender}
              setLeftCalender={setLeftCalender}
              rightCalender={rightCalender}
              setRightCalender={setRightCalender}
            />
          </Col>
          <Col
            xl={2}
            lg={3}
            md={4}
            sm={6}
            xs={6}
            className={styles.savingDatePickerWebPadding}
          >
            <TransactionDatePicker
              type={"To"}
              changeDate={changeDate}
              value={endDate}
              minDate={startDate}
              id="End_Date"
              extraPad="15px"
              align="right"
              leftCalender={leftCalender}
              setLeftCalender={setLeftCalender}
              rightCalender={rightCalender}
              setRightCalender={setRightCalender}
            />
          </Col>
          <Col
            xl={8}
            lg={6}
            md={4}
            xs={12}
            ref={ref}
            className={styles.savingsWebFilter}
          >
            <span
              className={styles.savingsPillsDropdownSelection}
              onClick={openTransactionTypePopup}
              style={{
                color:
                  selectedInputPill === "Processing"
                    ? "#FFCA4B"
                    : selectedInputPill === "Successful"
                    ? "#0DC014"
                    : selectedInputPill === "Hold"
                    ? "#FA5D05"
                    : selectedInputPill === "Failed"
                    ? "#FA274A"
                    : selectedInputPill === "Rejected"
                    ? "#FA274A"
                    : "",
              }}
            >
              <span
                className={styles.savingPillCircleColor}
                style={{
                  backgroundColor:
                    selectedInputPill === "Processing"
                      ? "#FFCA4B"
                      : selectedInputPill === "Successful"
                      ? "#0DC014"
                      : selectedInputPill === "Hold"
                      ? "#FA5D05"
                      : selectedInputPill === "Failed"
                      ? "#FA274A"
                      : selectedInputPill === "Rejected"
                      ? "#FA274A"
                      : "",
                }}
              ></span>
              {selectedInputPill}
              <img
                alt=""
                className={styles.savingPillsDropDownIcon}
                src={DownIcon}
              ></img>
            </span>
            {showTransactionTypePopup ? (
              <TransactionTypePopUp
                data={transactionValue}
                selectPill={pillSelection}
                openTransaction={openTransactionTypePopup}
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Row className={`${styles.savingsTableHeader}`}>
          {offlineTransactionFlow === true ? (
            ""
          ) : (
            <Col lg={3} md={4} sm={4} className={styles.savingsTableHeading}>
              <span>Sent to</span>
            </Col>
          )}
          <Col
            lg={3}
            md={6}
            sm={6}
            xs={6}
            className={`${styles.savingsTableHeading} ${styles.savingtableHideMobile}`}
          >
            <span>Transaction Id</span>
          </Col>
          <Col
            lg={offlineTransactionFlow === true ? 3 : 2}
            md={6}
            sm={6}
            xs={6}
            className={`${styles.savingsTableHeading} ${styles.savingsTableHeadingAmount}`}
          >
            <span>Amount</span>
          </Col>
          <Col
            lg={offlineTransactionFlow === true ? 3 : 2}
            md={4}
            sm={4}
            className={styles.savingsTableHeading}
          >
            <span>Date & Time</span>
          </Col>

          <Col
            lg={offlineTransactionFlow === true ? 3 : 2}
            md={6}
            sm={6}
            xs={6}
            className={`${styles.savingsTableHeading} ${styles.savingtableHideMobile}`}
          >
            <span>Status</span>
          </Col>
        </Row>
        <Row className={styles.mobileSavingsTableHeader}>
          <Col sm={6} xs={6} className={styles.savingsTableHeading}>
            <span>Sent To</span>
          </Col>
          <Col
            sm={6}
            xs={6}
            className={`${styles.savingsTableHeading} ${styles.savingsTableHeadingAmount} ${styles.mobileRightAlignment}`}
          >
            <span>Status</span>
          </Col>
        </Row>
        {collection && collection.length > 0 ? (
          Array.isArray(collection) &&
          collection.map((item, index) => {
            return (
              <Row className={styles.savingsTablePoints}>
                {offlineTransactionFlow === true ? (
                  ""
                ) : (
                  <Col
                    lg={3}
                    className={`${styles.savingTableType} ${styles.savingtableHideMobile}`}
                    onClick={() => {
                      setTranId(item.transactionId);
                      setTransactionItem(item);
                      openTransactionDetails();
                    }}
                  >
                    {/* <span className={styles.savingTableTransactionTypeValue}> */}
                    {SendToBox(item.beneName)}
                    {/* </span> */}
                  </Col>
                )}
                <Col
                  lg={3}
                  className={`${styles.savingTableType} ${styles.savingtableHideMobile} ${styles.sentToName}`}
                  onClick={() => {
                    setTranId(item.transactionId);
                    setTransactionItem(item);
                    openTransactionDetails();
                  }}
                >
                  {item.transactionId}
                </Col>
                <Col
                  lg={offlineTransactionFlow === true ? 3 : 2}
                  xs={6}
                  className={`${styles.savingTableType} ${styles.savingtableHideMobile}`}
                  onClick={() => {
                    setTranId(item.transactionId);
                    setTransactionItem(item);
                    openTransactionDetails();
                  }}
                >
                  <span className={styles.savingTableTransactionTypeValue}>
                    {item.amount
                      ? `₹${addCommasInPrice(parseFloat(item.amount))}`
                      : "--"}
                  </span>
                  {/* mobile date*/}
                  <span
                    className={`${styles.savingTableId} ${styles.savingShowMobile}`}
                  >
                    {seprateTimeAndDate(item.createdAt, "date")},
                    {seprateTimeAndDate(item.createdAt, "time")} IST
                  </span>
                </Col>
                <Col
                  lg={offlineTransactionFlow === true ? 3 : 2}
                  className={`${styles.savingTableType2} ${styles.savingtableHideMobile}`}
                  onClick={() => {
                    setTranId(item.transactionId);
                    setTransactionItem(item);
                    openTransactionDetails();
                  }}
                >
                  <span className={styles.savingTableTransactionTypeValue}>
                    {seprateTimeAndDate(item.createdAt, "date")}
                  </span>
                  <span className={styles.savingTableIdfortime}>
                    {seprateTimeAndDate(item.createdAt, "time")} IST
                  </span>
                </Col>
                <Col
                  sm={6}
                  xs={6}
                  className={`${styles.savingTableType} ${styles.savingtableShowMobile}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setTranId(item.transactionId);
                    setTransactionItem(item);
                    openTransactionDetails();
                  }}
                >
                  <p
                    className={styles.sentToName}
                    style={{ marginBottom: "5px" }}
                  >
                    {offlineTransactionFlow === true
                      ? item.transactionId
                      : item.beneName}
                  </p>
                  <p className={styles.savingTableTransactionTypeValue}>
                    {item.amount
                      ? `₹${addCommasInPrice(parseFloat(item.amount))}`
                      : "--"}
                  </p>
                </Col>
                <Col
                  lg={2}
                  xs={6}
                  sm={6}
                  className={`${
                    item.status === "FUND_RECEIVED" ||
                    item.status === "COMPLETED" ||
                    item.status === "PROCESSED" ||
                    item.status === "WAITING_FOR_FUND" ||
                    item.status === "HOLD" ||
                    item.status === "DOCUMENTS_REJECTED" ||
                    item.status === "PENDING" ||
                    item.status === "DOC_RECEIVED" ||
                    item.status === "A2_E_SIGNED" ||
                    item.status === "QUOTE_INITIATED" ||
                    item.status === "REFUNDED" ||
                    item.status === "Verified" ||
                    item.status === "Initiated"
                      ? `${styles.savingTableType2} ${styles.mobileRightAlignment2}`
                      : `${styles.mobileRightAlignment1} ${styles.savingTableType}`
                  } ${styles.savingsTableHeadingAmount}`}
                  onClick={() => {
                    setTranId(item.transactionId);
                    setTransactionItem(item);
                    openTransactionDetails();
                  }}
                >
                  <span className={`${styles.fundStatusHead}`}>
                    {item.status === "FUND_RECEIVED" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "COMPLETED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#0DC014" }}
                        ></span>
                        <span style={{ color: "#0DC014" }}>Successful</span>
                      </div>
                    ) : item.status === "REJECTED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#FA274A" }}
                        ></span>
                        <span style={{ color: "#FA274A" }}>Rejected</span>
                      </div>
                    ) : item.status === "DOCUMENTS_REJECTED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#FA5D05" }}
                        ></span>
                        <span style={{ color: "#FA5D05", marginLeft: "2px" }}>
                          On Hold
                        </span>
                      </div>
                    ) : item.status === "Initiated" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "REFUNDED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#767C8F" }}
                        ></span>
                        <span style={{ color: "#767C8F" }}>Refunded</span>
                      </div>
                    ) : item.status === "EXPIRED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#767C8F" }}
                        ></span>
                        <span style={{ color: "#767C8F" }}>Expired</span>
                      </div>
                    ) : item.status === "PROCESSED" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "PAYMENT_FAILURE" ? (
                      <div>
                        <span className={styles.savingPillCircleColor}></span>
                        <span style={{ color: "#FA274A" }}>Failed</span>
                      </div>
                    ) : item.status === "FAILED" ||
                      item.status === "CANCELLED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#FA274A" }}
                        ></span>
                        <span style={{ color: "#FA274A" }}>Failed</span>
                      </div>
                    ) : item.status === "Quote_Declined" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#FA274A" }}
                        ></span>
                        <span style={{ color: "#FA274A" }}>Failed</span>
                      </div>
                    ) : item.status === "WAITING_FOR_FUND" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "Verified" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "DOC_RECEIVED" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "QUOTE_INITIATED" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "A2_E_SIGNED" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "MANUAL_REVIEW" ? (
                      <div>
                        <img
                          alt=""
                          src={statementIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "-7px",
                          }}
                        />
                        <span style={{ color: "#FFCA4B", marginLeft: "10px" }}>
                          Processing
                        </span>
                      </div>
                    ) : item.status === "CREDITED" ? (
                      <div>
                        <span
                          className={styles.savingPillCircleColor}
                          style={{ backgroundColor: "#0DC014" }}
                        ></span>
                        <span style={{ color: "#0DC014" }}>Successful</span>
                      </div>
                    ) : item.status === null ? (
                      "--"
                    ) : (
                      item.status
                    )}
                  </span>
                  <span className={`${styles.savingTableId}`}>
                    {item.status === "FUND_RECEIVED" ? (
                      <span style={{ color: "#0061D3" }}>Fund Received</span>
                    ) : item.status === "COMPLETED" ? (
                      <span
                        className={styles.downloadswift}
                        onClick={(e) => downloadSwift(e, item)}
                      >
                        {offlineTransactionFlow === false
                          ? downloadingSWIFT
                            ? "Downloading..."
                            : "Download SWIFT"
                          : ""}
                      </span>
                    ) : item.status === "Initiated" ? (
                      <span style={{ color: "#0061D3" }}>
                        {offlineTransactionFlow === true
                          ? "Enter UTR"
                          : "Under Review"}
                      </span>
                    ) : item.status === "PROCESSED" ? (
                      <span>Transfer In Progress</span>
                    ) : item.status === "WAITING_FOR_FUND" ? (
                      <span style={{ color: "#0061D3" }}>Pay Now</span>
                    ) : item.status === "Verified" ? (
                      <span style={{ color: "#0061D3" }}>Pay Now</span>
                    ) : item.status === "HOLD" ||
                      item.status === "DOCUMENTS_REJECTED" ? (
                      <span style={{ color: "#0061D3" }}>Upload Documents</span>
                    ) : item.status === "QUOTE_INITIATED" ? (
                      <span style={{ color: "#0061D3" }}>Upload Documents</span>
                    ) : item.status === "DOC_RECEIVED" ? (
                      <span style={{ color: "#0061D3" }}>
                        {offlineTransactionFlow === true
                          ? ""
                          : "Complete A2 Sign"}
                      </span>
                    ) : // : item.status === "A2_E_SIGNED" ? (
                    // <span style={{ color: "#0061D3" }}>Complete Payment</span>
                    // )
                    item.status === "REFUNDED" ? (
                      <span style={{ color: "#0061D3" }}>
                        Amount is usually credited in 3-5 working days
                      </span>
                    ) : item.status === null ? (
                      ""
                    ) : (
                      ""
                    )}
                  </span>
                </Col>
              </Row>
            );
          })
        ) : (
          <Row className={styles.noDataFound}>
            <img
              src={noDataFound}
              alt=""
              style={{ height: "148px", width: "148px" }}
            ></img>
            <p className={styles.para1}>No Transaction yet</p>
            <p className={styles.para2}>
              Start sending money to people for recent
            </p>
            <p className={styles.para2}>transactions show here</p>
          </Row>
        )}
        <Row
          className={totalTransactionCount > 10 ? styles.savingsPagination : ""}
        >
          <Col
            lg={3}
            xs={4}
            className={styles.savingPaginationRowPad}
            onClick={() => goBack(currentPage)}
          >
            {totalTransactionCount <= 10 ? (
              ""
            ) : (
              <>
                <img alt="" src={leftIcon} style={{ marginRight: "8px" }}></img>
                <span
                  className={styles.savingPaginationButton}
                  style={{
                    cursor: currentPage !== 1 ? "pointer" : "default",
                  }}
                >
                  Previous
                </span>
              </>
            )}
          </Col>
          <Col
            lg={6}
            xs={4}
            className={styles.savingPaginationRowCount}
            style={{ textAlign: "center" }}
          >
            {totalPaginationPage === 0 || totalPaginationPage === undefined
              ? ""
              : `Page ${currentPage} of ${totalPaginationPage}`}
          </Col>
          <Col
            lg={3}
            xs={4}
            className={styles.savingPaginationRowPad}
            style={{ textAlign: "right" }}
            onClick={() => {
              goNext(currentPage);
            }}
          >
            {totalTransactionCount <= 10 ? (
              ""
            ) : (
              <>
                <span
                  className={styles.savingPaginationButton}
                  style={{
                    cursor:
                      currentPage !== totalPaginationPage
                        ? "pointer"
                        : "default",
                  }}
                >
                  Next
                </span>
                <img src={rightIcon} alt="" style={{ marginLeft: "8px" }}></img>
              </>
            )}
          </Col>
        </Row>
        {showTransactionDetails ? (
          <CashMgmtModal
            showModal={showTransactionDetails}
            openModal={openTransactionDetails}
          >
            <TransactionDetailsModal
              onHide={openTransactionDetails}
              stoTranId={tranId}
              transactionItem={transactionItem}
            />
          </CashMgmtModal>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default TransactionDetail;
